<script setup lang="ts">
    interface OverlayProps {
        noBlur?: boolean;
    }
    withDefaults(defineProps<OverlayProps>(), {
        noBlur: false,
    });
</script>
<template>
    <div :class="['atm-overlay fixed inset-0 h-screen w-full bg-black/40 ', { 'backdrop-blur-sm': !noBlur }]"></div>
</template>
